<template>
  <message-view
    :title="title"
    :message="message"
    elevation="0"
    icon="mdi-lock"
    color="error"
    outlined
  >
    <template #reference-id>
      <parent-reference-line-item-id tag="h2" />
    </template>
  </message-view>
</template>
<script>
import { mapGetters } from 'vuex'
import MessageView from '@/components/shared/MessageView'
import ParentReferenceLineItemId from '@/components/shared/ParentReferenceLineItemId'
import * as getTypes from '@/store/get-types'

export default {
  name: 'LockedView',
  components: {
    MessageView,
    ParentReferenceLineItemId
  },
  computed: {
    ...mapGetters({
      isDLAndDLRedemptionsDisabled: getTypes.GET_IS_DL_AND_DL_REDEMPTIONS_DISABLED
    }),
    title () {
      return this.$t('locked.title')
    },
    message () {
      return this.isDLAndDLRedemptionsDisabled
        ? this.$t('locked.temporaryLockMessage')
        : this.$t('locked.message')
    }
  }
}
</script>
<style lang="scss" scoped></style>
